/**
 * Local icons for the research surface.
 *
 * `react-icons/pi` is the sanctioned set; this file exists only for glyphs the
 * installed version does not export, drawn to the same Phosphor Light weight
 * so the surface stays visually consistent.
 */

import React from 'react';

export const PaperPlaneTiltIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 256 256" fill="none" stroke="currentColor" strokeWidth={12}
       strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
    <path d="M223.87 114.52 61.55 33.42a14 14 0 0 0-19.24 16.85l22.67 62.34a2 2 0 0 1 0 1.37l-22.67 62.35a14 14 0 0 0 19.24 16.85l162.32-81.1a14 14 0 0 0 0-25.06Z" />
    <path d="M110 128H64" />
  </svg>
);

export default PaperPlaneTiltIcon;
